import BaseModalElement from '../_modal/modal-element/modal-element';
import { defineElement } from '@webtides/element-js';
import UserCentrics from '../../../js/util/UserCentrics';
import { CountrySelectorCookie } from '../../../js/cookies/country-selector';
import { CountryService } from './country.service';

export default class CountrySelectorModal extends BaseModalElement {
    get siteConfigCountry() {
        return window.siteConfig().country;
    }

    connected() {
        super.connected();
        this.initializeCountrySelector().catch(error => {
            console.error('Error initializing country selector:', error);
        });
    }

    isDifferentFromSiteConfigCountry(countryName) {
        return this.siteConfigCountry !== countryName;
    }

    async initializeCountrySelector() {
        try {
            const countryName = await CountryService.get();
            if (!CountrySelectorCookie.get() && this.isDifferentFromSiteConfigCountry(countryName)) {
                // set a timeout to wait one second for UserCentrics is initialized
                setTimeout(() => {
                    try {
                        if (!UserCentrics.isConsentRequired()) {
                            this.open();
                            CountrySelectorCookie.add();
                        }
                    } catch (error) {
                        console.error('Error in setTimeout callback:', error);
                    }
                }, 1000);
            }
        } catch (e) {
            console.error('Error initializing country selector:', e);
        }
    }
}

defineElement('country-selector-modal', CountrySelectorModal);
